import React, { useState } from 'react';
import styled from 'styled-components';

import { Dialog } from '@clatter/ui';
import { FolderManagerItemTypes } from '../../../interfaces';
import { getFileNameAndExtensionFromFileName } from '../../../helpers';
import { useUpdateAssetMutation, useUpdateFolderMutation } from '../../../services';

import { FolderManagerDynamicForm } from './FolderManagerDynamicForm/FolderManagerDynamicForm';
import { baseApi } from '../../../services/baseApi';
import { useDispatch } from 'react-redux';
import { addNotification } from '../../../store';

const StyledContainer = styled.div`
  height: 90%;
  overflow: auto;
`;

const inputData = {
  fields: [
    {
      name: 'name',
      type: 'string',
      label: 'Name',
    },
  ],
};

const typeData = {
  validation: {
    type: 'object',
    properties: {
      name: {
        type: 'string',
        minLength: 1,
        errorMessage: {
          minLength: 'Name cannot be empty',
        },
      },
    },
    required: ['name'],
  },
};
export const FolderManagerDialog = ({
  dialogState,
  onDismiss,
  isLoading: isParentLoading,
}: IFolderManagerDialogProps) => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState<string | null>(null);

  const { editedItem } = dialogState || {};
  const editedItemType =
    editedItem?.type === FolderManagerItemTypes.FOLDER ? FolderManagerItemTypes.FOLDER : FolderManagerItemTypes.ASSET;

  const dialogTitle = `Rename ${editedItemType === FolderManagerItemTypes.FOLDER ? 'folder: ' : 'asset: '} ${
    editedItem?.name
  }`;

  const [updateAsset, { isLoading: isUpdateAssetLoading }] = useUpdateAssetMutation();
  const [updateFolder, { isLoading: isUpdateFolderLoading }] = useUpdateFolderMutation();

  const isLoading = isParentLoading || isUpdateFolderLoading || isUpdateAssetLoading;

  const fileNameAndExtension: { name: string; extension: string } =
    editedItemType !== FolderManagerItemTypes.FOLDER
      ? getFileNameAndExtensionFromFileName(editedItem?.name || '')
      : { name: editedItem?.name || '', extension: '' };

  const handleDialogDismiss = () => {
    //@todo:
    onDismiss(null);
  };

  const handleDynamicFormAction = async (data: any) => {
    if (!editedItem || !editedItem?.id) {
      console.error('Cannot submit form. No edited item or missing item ID!');
      return;
    }

    const trimmedName = data?.name?.trim();

    // this should be handled by
    // form but to be extra safe...
    if (!trimmedName) {
      setErrors('Error no name provided!');
      return;
    }

    try {
      const isFolder = editedItemType == FolderManagerItemTypes.FOLDER;
      if (isFolder) {
        await updateFolder({
          folderId: editedItem.id,
          data: { display_name: trimmedName, name: trimmedName },
        }).unwrap();
      } else {
        await updateAsset({
          assetId: editedItem.id,
          data: { display_name: `${trimmedName}.${fileNameAndExtension.extension}` },
        }).unwrap();
      }

      baseApi.custom.invalidateAllTags();

      dispatch(addNotification({
        type: 'success',
        message: `Successfully renamed ${isFolder ? 'folder' : 'asset'}.`
      }))
      handleDialogDismiss();
    } catch (error: any) {
      setErrors(error?.data?.error?.properties || `Error renaming ${editedItemType}`);
      // console.log('error', error);
    }
  };

  if (!dialogState.opened) {
    return null;
  }

  return (
    <>
      <Dialog title={dialogTitle} onCloseDialog={() => handleDialogDismiss()} open={dialogState?.opened} includeFooter>
      <StyledContainer>
        <FolderManagerDynamicForm
          formSchema={{ fields: inputData?.fields, validation: typeData?.validation }}
          initialValues={{ name: fileNameAndExtension.name }}
          onAction={handleDynamicFormAction}
          buttonsTargetContainerId="dialog-footer"
          isLoading={isLoading}
          errors={errors}
        />
      </StyledContainer>
      </Dialog>
    </>
  );
};
